/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Dual_Charger_BadgeInputs */

const en_dispatch_dual_charger_badge = /** @type {(inputs: Dispatch_Dual_Charger_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`also a charger`)
};

const fr_dispatch_dual_charger_badge = /** @type {(inputs: Dispatch_Dual_Charger_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aussi un point de charge`)
};

const ms_sg2_dispatch_dual_charger_badge = /** @type {(inputs: Dispatch_Dual_Charger_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`juga pengecas`)
};

/**
* | output |
* | --- |
* | "also a charger" |
*
* @param {Dispatch_Dual_Charger_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_dual_charger_badge = /** @type {((inputs?: Dispatch_Dual_Charger_BadgeInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Dual_Charger_BadgeInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_dual_charger_badge(inputs)
	if (locale === "fr") return fr_dispatch_dual_charger_badge(inputs)
	return ms_sg2_dispatch_dual_charger_badge(inputs)
});